import React from 'react';
import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
} from '@mui/material';
import { observer } from 'mobx-react-lite';
import { Controller } from 'react-hook-form';
import { StandardFieldProps } from './FieldTypes';
import HelperText from './HelperText';

const StandardSelectField = ({
  control,
  fieldName,
  field,
  readOnly,
}:StandardFieldProps) => {
  if (!field.enum
    || field.enum.length === 0
    || !field.enumLabels
    || field.enum.length !== field.enumLabels.length) {
    console.error('field definition enum or enumLabels missing.');
    return null;
  }
  return (
    <Controller
      name={fieldName}
      control={control}
      render={({
        field: {
          onChange,
          value,
        },
        fieldState: {
          isTouched,
          error,
        },
      }) => (
        <>
          <FormControl fullWidth disabled={field.readOnly || readOnly} size="small">
            <InputLabel id={`label-${fieldName}`}>{field.label}</InputLabel>
            <Select
              labelId={`label-${fieldName}`}
              id={fieldName}
              label={field.label}
              onChange={onChange}
              value={value || field.default || ''}
              name={fieldName}
            >
              {field.enum?.map((option:string, index:number) => (
                <MenuItem
                  key={option}
                  value={option}
                >
                  { /* @ts-expect-error can't be undefined because checking for that above */ }
                  {field.enumLabels[index]}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <HelperText
            name={fieldName}
            error={isTouched && error?.message}
            description={field.description}
          />
        </>
      )}
    />
  );
};

export default observer(StandardSelectField);
